export default __webpack_public_path__ + "static/tile-anatomy-dark-d6bee170864eedf5699cb1ee8576731628367df3e7984127bbefd300e4b08ccc.png";